<template>
  <div>
    <a-row>
      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="simiot-descriptions"
        >
          <a-descriptions-item label="操作类型">
            {{ batchOperationRecordInfo.operation_type }}
          </a-descriptions-item>

          <a-descriptions-item label="操作批次">
            {{ batchOperationRecordInfo.operation_no }}
          </a-descriptions-item>

          <a-descriptions-item label="操作时间">
            {{ batchOperationRecordInfo.created_at }}
          </a-descriptions-item>

          <a-descriptions-item label="备注">
            <span class="simiot-word-break-all">
              {{ batchOperationRecordInfo.remark }}
            </span>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="simiot-descriptions"
        >
          <a-descriptions-item label="订单编号">
            {{ batchOperationRecordInfo.order_no }}
          </a-descriptions-item>

          <a-descriptions-item label="划拨对象">
            {{ batchOperationRecordInfo.allocation_agent_name }}
          </a-descriptions-item>

          <a-descriptions-item label="操作人">
            {{ batchOperationRecordInfo.operator_name }}
          </a-descriptions-item>

          <a-descriptions-item label="重跑次数">
            <span class="simiot-word-break-all">
              {{ batchOperationRecordInfo.run_times }}
            </span>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="simiot-descriptions"
        >
          <a-descriptions-item label="项目编号">
            {{ batchOperationRecordInfo.item_no }}
          </a-descriptions-item>

          <a-descriptions-item label="划拨总数">
            {{ batchOperationRecordInfo.operation_count }}
          </a-descriptions-item>

          <a-descriptions-item label="划拨成功数">
            {{ batchOperationRecordInfo.success_count }}
          </a-descriptions-item>

          <a-descriptions-item label="划拨失败数">
            <span class="simiot-word-break-all">
              {{ batchOperationRecordInfo.failure_count }}
            </span>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

    </a-row>
    <a-row>
      <a-col>
        <span>
          注：执行卡号划拨作时，如果有一张卡划拨失败，不会影响其他卡的划拨，但本次划拨的操作结果为失败。
        </span>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'BatchOperationRecordAllocateCardsToTopAgentInfo',
  props: {
    batchOperationRecordInfo: {
      type: Object,
      required: true
    }
  }
}
</script>
